import { useCallback } from 'react';

import useGoogleTagManager from '@hooks/useGoogleTagManager';
import {
  assembleFeedbackOpenGTMEvent,
  assembleFeedbackSubmitGTMEvent,
  assembleGTMEvent,
  assembleManualClickGTMEvent,
} from '@utils/GoogleTagManager';
import {
  GOOGLE_TAG_MANAGER_CATEGORY_PAGES,
  GOOGLE_TAG_MANAGER_EVENT_MESSAGES,
} from '@utils/GoogleTagManager/interface';

const useTrackGTMEvents = () => {
  const { setGTMEvent } = useGoogleTagManager();

  const trackManualCardClick = useCallback(
    (title: string, url: string, modelNumber: string, modelId: string) => {
      setGTMEvent(
        assembleManualClickGTMEvent(
          `${GOOGLE_TAG_MANAGER_EVENT_MESSAGES.MANUAL_SELECTION}`,
          {
            manual: {
              title,
              url,
            },
            model: {
              modelNumber,
              id: modelId,
            },
          },
        ),
      );
    },
    [setGTMEvent],
  );

  const trackFeedbackOpen = useCallback(
    () => setGTMEvent(assembleFeedbackOpenGTMEvent()),
    [setGTMEvent],
  );

  const trackFeedbackSubmit = useCallback(
    () => setGTMEvent(assembleFeedbackSubmitGTMEvent()),
    [setGTMEvent],
  );

  const trackScanNameplateOpen = useCallback(() => {
    const base = assembleGTMEvent(
      GOOGLE_TAG_MANAGER_CATEGORY_PAGES.SCAN,
      'Scan-select',
    );
    setGTMEvent(base);
  }, [setGTMEvent]);

  const trackScanNameplateResult = useCallback(
    (scanId: string) => {
      const base = assembleGTMEvent(
        GOOGLE_TAG_MANAGER_CATEGORY_PAGES.SCAN,
        'Scan-nameplate',
      );
      setGTMEvent({ ...base, scanId });
    },
    [setGTMEvent],
  );

  return {
    trackManualCardClick,
    trackFeedbackOpen,
    trackFeedbackSubmit,
    trackScanNameplateOpen,
    trackScanNameplateResult,
  };
};

export default useTrackGTMEvents;
